<template>
  <button type="button"
          class="user-actions__link user-actions__link--auth"
          @click.prevent="showModal"
          :aria-label="$t('user_profile_enter')"
  >
    <span class="user-actions__icon">
      <svg width="27" height="25" >
        <use :xlink:href="spritePath + '#header_user'"></use>
      </svg>
    </span>
    <span v-if="isMobile" class="user-actions__label">{{ $t('user_profile_enter') }}</span>
  </button>
</template>

<script>
import { spritePath } from '@/mixins/spritePath'

export default {
  name: 'HeaderLogin',
  mixins: [spritePath],
  props: {
    isMobile: Boolean
  },
  data: function () {
    return {}
  },
  methods: {
    showModal () {
      this.$modal.show('auth-modal')
    }
  }
}
</script>
